const Notifications = {
  heading: "Notifications",
  subHeading: `Your notifications show tasks you need to complete or updates that we’ve made.
    Once you’ve completed the task or viewed the update, you can remove it.`,
  paymentNeeded: "Payment is needed from you",
  weHavePaid: "We've paid your claim",
  notificationsLink: "Notifications",
  notification: {
    paymentNeeded: "Payment is needed from you",
    weHavePaid: "We've paid your claim",
    removeLink: "remove",
    claimReferencePrefix: "Claim"
  },
  noNotificationsMessage: "You have 0 new notifications",
  youHave: "You have ",
  newNotification: "new notification",
  newNotifications: "new notifications",
  needYourAction: " that need your action",
  view: "View ",
  viewAriaLabel: "View claims notifications"
};

export default Notifications;
